export const COLUMN_ID = {
  select: 'select',
  name: 'name',
  followers: 'followers',
  engagementRate: 'engagementRate',
  location: 'location',
  joined: 'joined',
  categories: 'categories',
  gender: 'gender',
  age: 'age',
  vettingDecision: 'vettingDecision',
  socialNetworks: 'socialNetworks',
} as const;

export type ColumnId = (typeof COLUMN_ID)[keyof typeof COLUMN_ID];
